import request from '@/utils/request'
import { parseStrEmpty } from '@/utils/ruoyi'

// 查询用户列表
export function listUser(query) {
  return request({
    url: '/system/user/list',
    method: 'get',
    params: query,
  })
}

// 查询用户详细
export function getUser(userId) {
  return request({
    url: '/system/user/' + parseStrEmpty(userId),
    method: 'get',
  })
}

// 新增用户
export function addUser(data) {
  return request({
    url: '/system/user',
    method: 'post',
    data: data,
  })
}

// 修改用户
export function updateUser(data) {
  return request({
    url: '/system/user',
    method: 'put',
    data: data,
  })
}
// 修改用户邮箱认证中心
export function updateEmail(data) {
  return request({
    url: '/portal/updateEmail',
    method: 'post',
    data: data,
  })
}
// 修改用户邮箱 门户修改
export function updateEmailByPortal(data) {
  return request({
    url: '/portal/user/updateEmail',
    method: 'post',
    data: data,
  })
}
//修改密码 认证中心
export function updatePassword(data) {
  return request({
    url: '/portal/updatePassword',
    method: 'post',
    data: data,
  })
}
//修改密码 门户修改
export function updatePasswordByPortal(data) {
  return request({
    url: '/portal/user/updatePassword',
    method: 'post',
    data: data,
  })
}

//修改头像 认证中心修改
export function updateAvatarByAuth(data) {
  return request({
    url: '/portal/updateAvatar',
    method: 'post',
    data: data,
  })
}

// 删除用户
export function delUser(userId) {
  return request({
    url: '/system/user/' + userId,
    method: 'delete',
  })
}

// 用户密码重置
export function resetUserPwd(userId, password) {
  const data = {
    userId,
    password,
  }
  return request({
    url: '/system/user/resetPwd',
    method: 'put',
    data: data,
  })
}

// 用户状态修改
export function changeUserStatus(userId, status) {
  const data = {
    userId,
    status,
  }
  return request({
    url: '/system/user/changeStatus',
    method: 'put',
    data: data,
  })
}

// 查询用户个人信息
export function getUserProfile() {
  return request({
    url: '/system/user/profile',
    method: 'get',
  })
}

// 修改用户个人信息
export function updateUserProfile(data) {
  return request({
    url: '/system/user/profile',
    method: 'put',
    data: data,
  })
}

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
  const data = {
    oldPassword,
    newPassword,
  }
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'put',
    params: data,
  })
}

// 用户头像上传
export function uploadAvatar(data) {
  return request({
    url: '/system/user/profile/avatar',
    method: 'post',
    data: data,
  })
}

// 查询授权角色
export function getAuthRole(userId) {
  return request({
    url: '/system/user/authRole/' + userId,
    method: 'get',
  })
}

// 保存授权角色
export function updateAuthRole(data) {
  return request({
    url: '/system/user/authRole',
    method: 'put',
    params: data,
  })
}
//获取用户所在部门列表
export function getUserDeptList(userId) {
  return request({
    url: '/system/user/allDept?userId=' + userId,
    method: 'get',
  })
}
//切换部门

export function switchDept(userId, deptId) {
  return request({
    url: '/switch/login?userId=' + userId + '&deptId=' + deptId,
    method: 'get',
  })
}
